import { render, staticRenderFns } from "./config.vue?vue&type=template&id=6acfb096&scoped=true"
import script from "./config.vue?vue&type=script&lang=js"
export * from "./config.vue?vue&type=script&lang=js"
import style0 from "./config.vue?vue&type=style&index=0&id=6acfb096&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6acfb096",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6acfb096')) {
      api.createRecord('6acfb096', component.options)
    } else {
      api.reload('6acfb096', component.options)
    }
    module.hot.accept("./config.vue?vue&type=template&id=6acfb096&scoped=true", function () {
      api.rerender('6acfb096', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/goods/config.vue"
export default component.exports